export default __webpack_public_path__ + "static/redux-7f19dd0fba55be03e2100561d019a73d.png";